module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.showUpload = true
            }
          }
        }, [_c('v-icon', [_vm._v("upload")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Upload Kontoauszug")])]), _vm._v("\n        Kontobuch " + _vm._s(_vm.konto) + "\n      ")], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.monat = new Date(_vm.monat.setMonth(_vm.monat.getMonth() - 1))
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.monat = new Date()
      }
    }
  }, [_vm._v(_vm._s(_vm.$filters.date(_vm.monat, "MM.YYYY")))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.monat = new Date(_vm.monat.setMonth(_vm.monat.getMonth() + 1))
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.showAnleitung = true
      }
    }
  }, [_vm._v("Anleitung")])], 1)], 1), _vm._v(" "), _c('v-chip', {
    attrs: {
      "small": "",
      "label": "",
      "color": "green",
      "dark": ""
    }
  }, [_vm._v("BETA")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-data-table', {
    ref: "rechnungenTabelle",
    attrs: {
      "dense": "",
      "height": "calc(100vh - 270px)",
      "headers": _vm.headers,
      "items": _vm.kontobuch.buchungen,
      "search": _vm.search,
      "fixed-header": "",
      "items-per-page": -1,
      "hide-default-header": _vm.$vuetify.breakpoint.xsOnly,
      "no-data-text": "Für diesen Monat wurden bisher keine Buchungen hochgeladen.",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          staticClass: "hidden-sm-and-up"
        }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Nummer")]), _vm._v(" "), _c('th', [_vm._v("Bundesbruder")]), _vm._v(" "), _c('th', [_vm._v("Betrag")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          class: item.Abgeschlossen ? 'green lighten-4' : 'trasparent',
          on: {
            "click": function($event) {
              (_vm.selectedEintrag = item) && _vm.buchungClick()
            }
          }
        }, [_c('td', {
          attrs: {
            "width": "130px"
          }
        }, [_vm._v(_vm._s(_vm.$filters.date(item.Buchungstag.seconds * 1000, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Verwendungszweck))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item["Beguenstigter/Zahlungspflichtiger"]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(item.Betrag)))]), _vm._v(" "), (item.Betrag > 0 && item.file) ? _c('td', [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_done")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.Betrag > 0 && !item.file) ? _c('td', [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_upload")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.Betrag < 0 && item.file) ? _c('td', [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_done")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.Betrag < 0 && !item.file) ? _c('td', [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("cloud_upload")])], 1)], 1) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card', {
    staticClass: "text-right pa-2 my-2",
    attrs: {
      "outlined": ""
    }
  }, [_vm._v(" Summe: " + _vm._s(_vm._f("money")(_vm.kontobuch.summe)) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.kontobuch.buchungen.length) + " Buchungen | Hochgeladen am\n        " + _vm._s(_vm.$filters.date(_vm.kontobuch.geaendertAm, "DD.MM.YYYY")))])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-simple-table', {
    attrs: {
      "dense": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Verwendungszweck:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedEintrag.Verwendungszweck))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Begünstigter:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedEintrag["Beguenstigter/Zahlungspflichtiger"]))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Buchtungsdatum:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(_vm.selectedEintrag.Buchungstag.seconds * 1000, "DD.MM.YYYY")))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Betrag:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("money")(_vm.selectedEintrag.Betrag)))])])])]), _vm._v(" "), _c('v-card-text', [(_vm.selectRechnung) ? _c('v-btn', {
    attrs: {
      "outlined": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.showRechnung = true
      }
    }
  }, [_c('v-icon', [_vm._v("launch")]), _vm._v(" Rechnung " + _vm._s(_vm.selectRechnung.rechnungsnummer))], 1) : _c('v-btn', {
    attrs: {
      "block": "",
      "outlined": ""
    }
  }, [_vm._v("Keine passende Rechnung gefunden")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betreff/Veranstaltung"
    },
    model: {
      value: (_vm.selectedEintrag.Betreff),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Betreff", $$v)
      },
      expression: "selectedEintrag.Betreff"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-autocomplete', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": _vm.artItems,
      "label": "Art"
    },
    model: {
      value: (_vm.selectedEintrag.Art),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Art", $$v)
      },
      expression: "selectedEintrag.Art"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1 pr-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Betrag"
    },
    model: {
      value: (_vm.selectedEintrag.Betrag1),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Betrag1", $$v)
      },
      expression: "selectedEintrag.Betrag1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "2. Betrag"
    },
    model: {
      value: (_vm.selectedEintrag.Betrag2),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Betrag2", $$v)
      },
      expression: "selectedEintrag.Betrag2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1 pr-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": ['Keine Angabe', '19%', '7%'],
      "label": "MwSt-Satz"
    },
    model: {
      value: (_vm.selectedEintrag.MwSt1),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "MwSt1", $$v)
      },
      expression: "selectedEintrag.MwSt1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    staticClass: "mb-2",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "items": ['Keine Angabe', '19%', '7%'],
      "label": "2. MwSt-Satz"
    },
    model: {
      value: (_vm.selectedEintrag.MwSt2),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "MwSt2", $$v)
      },
      expression: "selectedEintrag.MwSt2"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    staticClass: "mb-2",
    attrs: {
      "rows": "3",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Bemerkung"
    },
    model: {
      value: (_vm.selectedEintrag.Bemerkung),
      callback: function($$v) {
        _vm.$set(_vm.selectedEintrag, "Bemerkung", $$v)
      },
      expression: "selectedEintrag.Bemerkung"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-file-input', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "dense": "",
      "label": "Rechnung hochladen"
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1)], 1)], 1), _vm._v("\n        " + _vm._s(this.selectedEintrag.file) + "\n        "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.setAbgeschlossen()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "persistent": ""
    },
    model: {
      value: (_vm.showUpload),
      callback: function($$v) {
        _vm.showUpload = $$v
      },
      expression: "showUpload"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Bank Daten hochladen ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    staticClass: "mt-2",
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("\n          Achtung: Monat erst hochladen wenn alle Buchungen vorhanden sind. Ein nachträgliches Hinzufügen oder\n          Entfernen von Buchungen der Liste ist nicht möglich.\n        ")]), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "accept": ".csv",
      "prepend-icon": "attach_file",
      "label": "CSV-Datei zum importieren auswählen"
    },
    model: {
      value: (_vm.csvDatei),
      callback: function($$v) {
        _vm.csvDatei = $$v
      },
      expression: "csvDatei"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpload = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadData()
      }
    }
  }, [_vm._v("hochladen")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showImport),
      callback: function($$v) {
        _vm.showImport = $$v
      },
      expression: "showImport"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Daten importieren (" + _vm._s(_vm.eintrage.length) + ") ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Buchungstag")]), _vm._v(" "), _c('th', [_vm._v("Person")]), _vm._v(" "), _c('th', [_vm._v("Verwendungszweck")]), _vm._v(" "), _c('th', [_vm._v("Betrag")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.eintrage), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.Buchungstag, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item["Beguenstigter/Zahlungspflichtiger"]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Verwendungszweck))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(item.Betrag)))])])
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showImport = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importData
    }
  }, [_vm._v("Importieren")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: (_vm.showAnleitung),
      callback: function($$v) {
        _vm.showAnleitung = $$v
      },
      expression: "showAnleitung"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" Anleitung Kontobuch ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("1.")]), _vm._v(" "), _c('td', [_vm._v("\n                Exportiere die Buchungsübersicht der Sparkasse als CSV-Datei. Achte auf Vollständigkeit des Monats\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2.")]), _vm._v(" "), _c('td', [_vm._v("\n                Lade die Datei in dieser Ansicht hoch. Dabei werden Buchungen die nicht in den Monat gehören\n                automatisch entfernt.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3.")]), _vm._v(" "), _c('td', [_vm._v("\n                Füge zu jeder Buchung die geforderten Informationen hinzu. Solltest du Felder nicht benennen können\n                schreibe \"Keine Ahnung\" hinein.\n              ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4.")]), _vm._v(" "), _c('td', [_vm._v("Sollte der Buchungsbetrag negativ sein musst du eine Rechnung hochladen.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5.")]), _vm._v(" "), _c('td', [_vm._v("Wenn alle Felder einer Buchung ausgefüllt sind klicke auf \"Fertig\"")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6.")]), _vm._v(" "), _c('td', [_vm._v("\n                Wenn der Monat abgeschlossen ist oder du zwischenspeichern willst klicke auf das Speichersymbol in der\n                rechten, oberen Ecke.\n              ")])])])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.showAnleitung = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  }), _vm._v(" "), _c('dialogRechnung', {
    attrs: {
      "visible": _vm.showRechnung,
      "rechnungid": _vm.selectRechnung.id
    },
    on: {
      "update:visible": function($event) {
        _vm.showRechnung = $event
      },
      "close": function($event) {
        _vm.showRechnung = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fbaf873"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/kontobuch.vue
// module id = 795
// module chunks = 15